import * as React from 'react'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import HtmlHead from '../components/HtmlHead'
import type { AppStateType } from '../reducers/appstate'
import { withRouter } from 'next/router'
import { GlobalStyle, colors } from '@components/shared'
import BenefitsLandingPage from '@components/BenefitsLandingPage'
import type { PropsType } from '@components/BenefitsLandingPage'
import { openSubscribe } from '../actions/navigationActions'
import { dismissIntercom } from '@services/intercom'

function LandingPage (_props: PropsType): React.ReactNode {
  React.useEffect((): void => {
    dismissIntercom()
  }, [])
  const copy = {
    header: 'Tune into your desires',
    subHeader: 'Dipsea is the app for erotic audio stories designed to help you get in the mood and explore pleasure on your own terms.',
    benefitsArr: [
      'A safe space to connect with your desires',
      '1,000+ stories with diverse characters & plots',
      'Expertly made by writers, actors, & producers'
    ],
    ctaText: 'TRY DIPSEA',
    trialLanguage: 'ENJOY 25% OFF',
    subBody: '7-day free trial. Cancel anytime.'
  }
  const quotes = [
    <span key={'quote-1'}>“I’ve been using this app for over a year now and the stories are amazing. Perfect for <b>exploring new things.</b>”</span>,
    <span key={'quote-2'}>“Dipsea has helped me <b>open up to my sensuality</b> in ways I couldn’t have imagined.”</span>,
    <span key={'quote-3'}>“I really appreciate all the believable scenarios, the <b>extraordinary talent</b> of the folks writing and recording the stories, and the plethora of LGBTQ+ content.”</span>,
    <span key={'quote-4'}>“Listening to stories together has helped my partner and I discover what <b>really turns each other on</b>.”</span>,
    <span key={'quote-5'}>“I’ve been working through my sexual shame in therapy and Dipsea has been a really helpful tool to allow me to explore and <b>get comfortable with my body.</b>”</span>
  ]
  return (
    <>
      <GlobalStyle backgroundColor={colors.white} />
      <HtmlHead
        title={`Dipsea | Get lost in a steamy fantasy world`}
        description={
          'Get access to the entire Dipsea library to explore 1,000+ sexy audio stories, soothing sleep scenes, steamy POV role-plays, and more. '
        }
      />
      <BenefitsLandingPage color={'pink'} inlineSubscribe={true} copyText={copy} quotes={quotes}/>
    </>
  )
}

const mapStateToProps = (_state: AppStateType): any => {
  return {
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>): any => {
  return {
    openSubscribe: (): void => dispatch(openSubscribe())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LandingPage) as any) as any
